export const checkTabletIpadPlatform = (): boolean => {
	if (/iPad|iPhone|iPod/.test(navigator.platform)) {
		return true;
	} else if (
		/(ipad|tablet|android|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
			navigator.userAgent.toLowerCase()
		)
	) {
		return true;
	} else {
		return navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
	}
};

export function IsIpad() {
	return navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
}
